module.exports = __webpack_public_path__ + "src/assets/img/pause.0f25c057.png";